import {
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { chain, LoadRealTimeInventory, LoadRealTimePrices, WaitForData } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}


// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
replaceInChain(
    chain,
    LoadRealTimePrices,
    props => {
        props.inventoryLoaded = true;

    },
);

replaceInChain(
    chain,
    LoadRealTimeInventory,
    props => {
        props.inventoryLoaded = true;
    },
);
replaceInChain(
    chain,
    WaitForData,
    props => {
    
    },
);

